const navigationRoutes = {
  // Schema management (home)
  SCHEMAS: "/home",
  SCHEMA_ADD: "/schemas/add",
  SCHEMA_EDIT: (schemaName: string) => `/schemas/edit/${schemaName}`,
  SCHEMA_EDIT_ROUTE: "/schemas/edit/:schemaName",
  SCHEMA_RENDER: (schemaName: string) => `/from/${schemaName}`,
  SCHEMA_RENDER_ROUTE: "/from/:schemaName",

  // Tenant profile management
  TENANT_PROFILE: "/tenant-profile",
  TENANT_PROFILE_ADD: "/tenant-profile/add",
  TENANT_PROFILE_EDIT: (id: string) => `/tenant-profile/edit/${id}`,
  TENANT_PROFILE_EDIT_ROUTE: "/tenant-profile/edit/:id",

  // Social configuration management
  SOCIAL_CONFIGURATION: "/social-configuration",
  SOCIAL_CONFIGURATION_ADD: "/social-configuration/add",
  SOCIAL_CONFIGURATION_EDIT: (id: string) => `/social-configuration/edit/${id}`,
  SOCIAL_CONFIGURATION_EDIT_ROUTE: "/social-configuration/edit/:id",

  // User management
  USERS: "/tenant/users",
  USER_DETAILS: (userId: string) => `/tenant/user-detail/${userId}`,
  USER_DETAILS_ROUTE: "/tenant/user-detail/:userId",
  USER_ADD: "/tenant/users/add",
  USER_EDIT: (id: string) => `/tenant/users/edit/${id}`,
  USER_EDIT_ROUTE: "/tenant/users/edit/:id",
  ROLES: "/tenant/roles",
  ROLE_ADD: "/tenant/roles/add",
  ROLE_EDIT: (id: string) => `/tenant/roles/edit/${id}`,
  ROLE_EDIT_ROUTE: "/tenant/roles/edit/:id",
  PERMISSIONS: "/tenant/permission",

  // Nps User List
  NPS_USER_LIST: "/nps/user_list",
  NPS_USER_LIST_ADD: "/nps/user-list/add",
  NPS_USER_LIST_EDIT: (id: string) => `/nps/user-list/edit/${id}`,
  NPS_USER_LIST_EDIT_ROUTE: "/nps/user-list/edit/:id",

  // Module management
  MODULE: (schemaName: string) => `/module/${schemaName}`,
  MODULE_ROUTE: "/module/:schemaName",
  MODULE_ADD: (schemaName: string) => `/module/${schemaName}/add`,
  MODULE_ADD_ROUTE: "/module/:schemaName/add",
  MODULE_EDIT: (schemaName: string, id: string) =>
    `/module/${schemaName}/edit/${id}`,
  MODULE_EDIT_ROUTE: "/module/:schemaName/edit/:id",

  // Workflow management
  WORKFLOW_LIST: "/workflow/workflows",
  WORKFLOW_ADD: "/workflow/workflows/add",
  WORKFLOW_EDIT: (id: string) => `/workflow/workflows/edit/${id}`,
  WORKFLOW_EDIT_ROUTE: "/workflow/workflows/edit/:id",

  // Print Format
  PRINT_FORMAT: "/print-format",
  PRINT_FORMAT_ADD: "/print-format/add",
  PRINT_FORMAT_EDIT: (id: string) => `/print-format/edit/${id}`,
  PRINT_FORMAT_EDIT_ROUTE: "/print-format/edit/:id",

  // Letter Head
  LETTER_HEAD: "/letter-head",
  LETTER_HEAD_ADD: "/letter-head/add",
  LETTER_HEAD_EDIT: (id: string) => `/letter-head/edit/${id}`,
  LETTER_HEAD_EDIT_ROUTE: "/letter-head/edit/:id",

  // Email Configuration
  EMAIL_CONFIGURATION: "/email-configuration",
  EMAIL_CONFIGURATION_ADD: "/email-configuration/add",
  EMAIL_CONFIGURATION_EDIT: (id: string) => `/email-configuration/edit/${id}`,
  EMAIL_CONFIGURATION_EDIT_ROUTE: "/email-configuration/edit/:id",

  // User Permissions
  USER_PERMISSIONS: "/tenant/user-permissions",
  USER_PERMISSIONS_ADD: "/tenant/user-permissions/add",
  USER_PERMISSIONS_EDIT: (id: string) => `/tenant/user-permissions/edit/${id}`,
  USER_PERMISSIONS_EDIT_ROUTE: "/tenant/user-permissions/edit/:id",

  // SMS Configuration
  SMS_CONFIGURATION: "/sms-configuration",
  SMS_CONFIGURATION_ADD: "/sms-configuration/add",
  SMS_CONFIGURATION_EDIT: (id: string) => `/sms-configuration/edit/${id}`,
  SMS_CONFIGURATION_EDIT_ROUTE: "/sms-configuration/edit/:id",

  ///Notification
  Notification: "/notification",
  Notification_ADD: "/notification/add",

  // State management
  STATE_MASTERS: "/workflow/state-masters",
  STATE_MASTER_ADD: "/workflow/state-masters/add",
  STATE_MASTER_EDIT: (id: string) => `/workflow/state-masters/edit/${id}`,
  STATE_MASTER_EDIT_ROUTE: "/workflow/state-masters/edit/:id",

  // Action management
  ACTION_MASTERS: "/workflow/action-masters",
  ACTION_MASTER_ADD: "/workflow/action-masters/add",
  ACTION_MASTER_EDIT: (id: string) => `/workflow/action-masters/edit/${id}`,
  ACTION_MASTER_EDIT_ROUTE: "/workflow/action-masters/edit/:id",

  // Translation management
  TRANSLATIONS: "/translations",
  TRANSLATION_ADD: "/translations/add",
  TRANSLATION_EDIT: (id: string) => `/translations/edit/${id}`,
  TRANSLATION_EDIT_ROUTE: "/translations/edit/:id",

  // Import management
  IMPORTS: "/imports",
  IMPORT_ADD: "/imports/add",
  IMPORT_DETAIL: (importId: string) => `/imports/${importId}`,
  IMPORT_DETAIL_ROUTE: "/imports/:importId",

  PRINT_ROUTE: "/print/:schemaName/:recordId",
  PRINT: (schemaName: string, recordId: string) =>
    `/print/${schemaName}/${recordId}`,
  // System
  ROUTE_DETAILS: "/route-details",

  // Authentication
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOT_PASSWORD: "/forgot-password",
  FORGOT_PASSWORD_RESET: (id: string) => `/forgot-password-reset/${id}`,
  FORGOT_PASSWORD_RESET_ROUTE: "/forgot-password-reset/:id",
} as const;

export default navigationRoutes;
